import React from "react";
import { cn } from "@fmc-digital/ui";

export interface PasswordStrengthMeterProps {
  metCount: number;
  total: number;
  className?: string;
}

const strengthColors = [
  "bg-red-500",
  "bg-amber-700",
  "bg-green-600",
  "bg-black",
];

const getActiveBars = (metCount: number, total: number) => {
  if (metCount >= total) return 4;
  if (metCount >= 6) return 3;
  if (metCount >= 4) return 2;
  if (metCount >= 2) return 1;
  return 0;
};

export const PasswordStrengthMeter: React.FC<PasswordStrengthMeterProps> = ({ metCount, total, className }) => {
  const activeBars = getActiveBars(metCount, total);
  return (
    <div className={cn("flex gap-1", className)} data-testid="password-strength-meter">
      {[0, 1, 2, 3].map((idx) => (
        <div
          key={idx}
          className={cn(
            "flex-1 transition-all duration-300",
            idx < activeBars ? strengthColors[idx] : "bg-gray-200"
          )}
          style={{ height: "4px", borderRadius: "32px" }}
        />
      ))}
    </div>
  );
};
